export default "__VITE_ASSET__1bd6de64__"